<script>
    import Spinner from "../../../components/spinner/Spinner.svelte";
    import {apiFetch, apiPost} from '../../../apiFetch';
    import {createForm} from "svelte-forms-lib";
    import {Alert} from 'sveltestrap';
    import {focus,goto} from "@sveltech/routify/runtime";
    import {_} from 'svelte-i18n';
    import * as yup from "yup";
    import {getContext} from "svelte";
    const MyAnalytics = getContext('MyAnalytics');

    let formError = null;
    let organizations = [];

    const {form, errors, handleChange, handleSubmit} = createForm({
        initialValues: {
            name: "",
            eventOrganization: 0
        },
        validationSchema: yup.object().shape({
            name: yup
                    .string()
                    .required(),
            eventOrganization: yup
                    .number()
                    .required(),
        }),
        onSubmit: values => {
          const organizationId = parseInt(values.eventOrganization);
            MyAnalytics.logEvent('event_new_submit_click', { organization_id: organizationId});

            values.eventOrganization = [{
                organization: organizationId,
            }];

            delete values['organization'];

            apiPost('/events', {event: values})
                    .then((result) => {
                        if (result.status !== 201) {
                            formError = result.errors.join('<br>');
                        } else {
                            $goto('../:eventId', {eventId: result.event.id});
                        }
                    })
                    .catch((error) => {
                        alert(error);
                    });
        }
    });

    async function loader() {
        const organizationsResult = await apiFetch('/organizations');
        if (organizationsResult.status !== 200) {
            formError = $_('page.event.new.error.noOrganizationsFound', {values: {status: organizationsResult.status}});
        }

        organizations = organizationsResult.organizations;

        // Set default value for selectbox to primary organization
        if (organizations.length) {
            $form.eventOrganization = organizations[0].id;
        } else {
            formError = $_('page.event.new.error.noOrganizationsFound', {values: {status: organizationsResult.status}});
        }
    }

    let ready = loader();

</script>

<div class="container">
    <h2>{$_('page.event.new.title')}</h2>

    <div>
        <p>{$_('page.event.new.intro')}</p>
    </div>

    {#await ready}
        <Spinner/>
    {:then data}
        {#if formError}
            <Alert color="danger">{formError}</Alert>
        {/if}
        <form on:submit={handleSubmit} class="content">
            <div class="form-group">
                <label for="name">{$_('page.event.new.eventName')}</label>
                <input
                        id="name"
                        name="name"
                        on:change={handleChange}
                        bind:value={$form.name}
                        class="form-control {$errors.name ? 'is-invalid' : ''}"
                        use:focus
                />
                {#if $errors.name}
                    <div class="invalid-feedback">{$errors.name}</div>
                {/if}
            </div>

            <div class="form-group">
                <label for="eventOrganization">{$_('page.event.new.organization')}</label>
                <select
                        id="eventOrganization"
                        name="eventOrganization"
                        on:change={handleChange}
                        bind:value={$form.eventOrganization}
                        class="form-control"
                >
                    {#each organizations as { id, name }}
                        <option value="{id}">{name}</option>
                    {/each}
                </select>
                <small id="eventOrganizationHelp"
                       class="form-text text-muted">{$_('page.event.new.help.missingEventOrganization')}</small>
            </div>
            <button class="btn btn-primary" type="submit">Next</button>
        </form>
    {:catch error}
        {@debug error}
        <p>An error occurred!</p>
    {/await}
</div>